/**
 * PEP Cart UI glue
 * ------------------------------------------------------------------
 * The custom header renders a server-side cart count
 * (<span data-pep-cart-count>{{ cart.item_count }}</span>) that does NOT
 * listen to the theme's AJAX cart events, so it only changed on refresh.
 * The custom "Add" buttons are also plain submit buttons, so they get none
 * of Horizon's add-to-cart animation.
 *
 * This script:
 *   1. Keeps every [data-pep-cart-count] badge in sync on `cart:update`
 *      (authoritative count from /cart.js) and pops a bump animation.
 *   2. Gives the custom Add buttons a lightweight loading -> added animation.
 */
(function () {
  var COUNT_SEL = '[data-pep-cart-count]';
  var CART_BTN_SEL = '.pep-header__cartbtn';
  var ATC_FORM_SEL = '.pep-prod__form, .pep-col__form, .pep-pdp__form';
  var seq = 0;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function bump(el) {
    if (!el) return;
    el.classList.remove('pep-cart-bump');
    void el.offsetWidth; // reflow so the animation restarts
    el.classList.add('pep-cart-bump');
  }

  function applyCount(n, animate) {
    document.querySelectorAll(COUNT_SEL).forEach(function (el) {
      var changed = el.textContent.trim() !== String(n);
      el.textContent = n;
      if (n > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
      if (changed && animate) bump(el);
    });
    if (animate && n > 0) document.querySelectorAll(CART_BTN_SEL).forEach(bump);
  }

  function sync(animate) {
    var mine = ++seq;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (mine === seq) applyCount(cart.item_count, animate); // ignore stale responses
      })
      .catch(function () {});
  }

  /* ---- Add-to-cart button feedback ---------------------------------- */
  function markAdding(form) {
    var btn = form.querySelector('.pep-prod__add, .pep-col__add, .pep-pdp__add, button[type="submit"]');
    if (!btn || btn.disabled) return;
    btn.classList.add('pep-atc-loading');
    // Failsafe: never leave the spinner stuck if no cart:update arrives.
    setTimeout(function () { btn.classList.remove('pep-atc-loading'); }, 4000);
  }

  function clearAdding(didError) {
    document.querySelectorAll('.pep-atc-loading').forEach(function (btn) {
      btn.classList.remove('pep-atc-loading');
      if (didError) return;
      btn.classList.add('pep-atc-done');
      setTimeout(function () { btn.classList.remove('pep-atc-done'); }, 1300);
    });
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (form && form.matches && form.matches(ATC_FORM_SEL)) markAdding(form);
    },
    true
  );

  document.addEventListener('cart:update', function (e) {
    var didError = !!(e.detail && e.detail.data && e.detail.data.didError);
    clearAdding(didError);
    sync(true);
  });

  // Keep the count correct on load and on bfcache restores (no bump).
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) sync(false);
  });
})();
